<template>  
  <v-navigation-drawer v-model="drawerLocal" absolute temporary>
    <v-list class="pa-1">
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <img src="https://randomuser.me/api/portraits/men/85.jpg">
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>John Leider</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-list class="pt-0" dense>
      <v-divider></v-divider>
      <v-list-tile v-for="item in items" :key="item.title" @click="">
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
      <!--<div id="left-scroll">      
        <v-img class="white--text" height="120px" :src="require('@/assets/img/bg/1.jpg')">        
          <v-list-tile style="margin-top:55px" avatar @click="$router.push({path:'/profile'});">
            <v-list-tile-avatar color="blue-grey">
              <img  v-if="avatar" />
              <span v-else class="white--text headline">A</span>            
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="title" style="color:#fff">john doe</v-list-tile-title>
              <small class="light-green--text"><v-icon color="green lighten-2">fa-circle</v-icon> online</small>
              <!--<small class="red--text" v-else><v-icon color="red">fa-circle</v-icon> offline</small>-->                           
            <!--</v-list-tile-content>
          </v-list-tile>
        </v-img>
        <v-timeline
          align-top
          dense
        >
          <v-timeline-item
            color="pink"
            small
          >
            <v-layout pt-3>
              <v-flex xs3>
                <strong>1 sept</strong>
              </v-flex>
              <v-flex>
                <strong>New Icon</strong>
                <div class="caption">Mobile App</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item
            color="teal lighten-3"
            small
          >
            <v-layout wrap pt-3>
              <v-flex xs3>
                <strong>3 sept</strong>
              </v-flex>
              <v-flex>
                <strong>Design Stand Up</strong>
                <div class="caption mb-2">Hangouts</div>
                <v-avatar>
                  <v-img
                    src="https://avataaars.io/?avatarStyle=Circle&topType=LongHairFrida&accessoriesType=Kurt&hairColor=Red&facialHairType=BeardLight&facialHairColor=BrownDark&clotheType=GraphicShirt&clotheColor=Gray01&graphicType=Skull&eyeType=Wink&eyebrowType=RaisedExcitedNatural&mouthType=Disbelief&skinColor=Brown"
                  ></v-img>
                </v-avatar>
                <v-avatar>

                  <v-img
                    src="https://avataaars.io/?avatarStyle=Circle&topType=ShortHairFrizzle&accessoriesType=Prescription02&hairColor=Black&facialHairType=MoustacheMagnum&facialHairColor=BrownDark&clotheType=BlazerSweater&clotheColor=Black&eyeType=Default&eyebrowType=FlatNatural&mouthType=Default&skinColor=Tanned"
                  ></v-img>
                </v-avatar>
                <v-avatar>
                  <v-img
                    src="https://avataaars.io/?avatarStyle=Circle&topType=LongHairMiaWallace&accessoriesType=Sunglasses&hairColor=BlondeGolden&facialHairType=Blank&clotheType=BlazerSweater&eyeType=Surprised&eyebrowType=RaisedExcited&mouthType=Smile&skinColor=Pale"
                  ></v-img>
                </v-avatar>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item
            color="pink"
            small
          >
            <v-layout pt-3>
              <v-flex xs3>
                <strong>17 sept</strong>
              </v-flex>
              <v-flex>
                <strong>Lunch break</strong>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item
            color="teal lighten-3"
            small
          >
            <v-layout pt-3>
              <v-flex xs3>
                <strong>9-11 okt</strong>
              </v-flex>
              <v-flex>
                <strong>Finish Home Screen</strong>
                <div class="caption">Web App</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>        
      </div>-->      
</template>
<script>
export default {
  name : 'left-drawer',  
  components: {
  },
  props :{
    drawer : {
      type: Boolean,
      default: false,
    },
  },
  data:()=>({
    drawerLocal : false,
    items : [],
  }),
  created(){
     this.$emit('update:drawer', JSON.parse(this.drawer))
  },
  watch: {            
    drawer(newVal){this.drawerLocal = newVal; console.log(newVal);
    this.$emit('update:drawer', JSON.parse(this.drawer))},
  }
};
</script>


